import { render, staticRenderFns } from "./Colores.vue?vue&type=template&id=184d359d&"
import script from "./Colores.vue?vue&type=script&lang=js&"
export * from "./Colores.vue?vue&type=script&lang=js&"
import style0 from "./Colores.vue?vue&type=style&index=0&id=184d359d&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports